'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* Company facts from the HubSpot record; delivery context from the 'Foodics - Pilot & Success' Linear project. CONFIRM BEFORE SHIPPING: which channels are live, what the agent handles end to end, and what escalates. No logo asset yet.
 *
 * No stats row and no results table: no cleared figure exists for Foodics.
 * Add the stats, the table and the six-place number check from the
 * customer-stories skill in the same commit that lands real numbers. */
const FoodicsCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Foodics"
        title={t.customerStories['foodics_hero_title']}
        subtitle={t.customerStories['foodics_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'Foodics',
          customerName: 'Foodics',
          company: t.customerStories['foodics_company_description'],
          industry: t.customerStories['foodics_industry'],
          websiteUrl: 'https://www.foodics.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['foodics_location'],
            },
          ],
          keyResults: [
            t.customerStories['foodics_key_result_1'],
            t.customerStories['foodics_key_result_2'],
            t.customerStories['foodics_key_result_3'],
            t.customerStories['foodics_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['foodics_intro']}</p>

        <h2>{t.customerStories['foodics_challenge_title']}</h2>
        <p>{t.customerStories['foodics_challenge_p1']}</p>
        <p>{t.customerStories['foodics_challenge_p2']}</p>
        <p>{t.customerStories['foodics_challenge_p3']}</p>

        <h2>{t.customerStories['foodics_solution_title']}</h2>
        <p>{t.customerStories['foodics_solution_p1']}</p>
        <p>{t.customerStories['foodics_solution_p2']}</p>
        <p>{t.customerStories['foodics_solution_p3']}</p>

        <h2>{t.customerStories['foodics_impact_title']}</h2>
        <p>{t.customerStories['foodics_impact_p1']}</p>
        <p>{t.customerStories['foodics_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default FoodicsCaseStudy;
